export default __webpack_public_path__ + "static/media/animation_password_en.9bb6bdd4.gif";